export default function LogoMain({ isLarge, isLight }) {
  return (
    isLight ? <img src="/logo/light-logo.png" className={isLarge ? "w-30" : "w-20"} /> : <img src="/logo/logo.svg" className={isLarge ? "w-30" : "w-20"} />
  );
}
